import React from 'react';
export function HeroSection() {
  return <section className="relative w-full min-h-[100svh] flex flex-col text-center px-5 py-6 sm:py-10 items-center justify-center overflow-hidden bg-[#0A0A0A] pt-[20px] pb-[20px]" data-id="element-123">
      {/* Logo */}
      <span className="text-[#FF6B00] text-lg sm:text-xl font-black tracking-widest mb-2.5 uppercase" data-id="element-124">
        🏀 BASKETBALL BEREIT 360™
      </span>

      {/* Badge */}
      <div className="mb-3 sm:mb-4" data-id="element-125">
        <span className="bg-[#FF6B00]/10 text-[#FF6B00] text-[11px] sm:text-xs font-bold px-3 py-1.5 rounded-full uppercase tracking-wide border border-[#FF6B00]/20" data-id="element-126">
          🏀 Von 500+ Trainern in Deutschland genutzt
        </span>
      </div>

      {/* Main headline */}
      <h1 className="font-black text-white max-w-4xl text-[1.7rem] sm:text-4xl md:text-6xl leading-[1.1] mb-3 sm:mb-4 tracking-tight" data-id="element-127">
        Planen Sie Ihr gesamtes Basketball-Jahr{' '}
        <span className="text-[#FF6B00]" data-id="element-128">in weniger als 5 Minuten.</span>
      </h1>

      {/* Subheadline */}
      <p className="text-[#B0B0C0] text-sm sm:text-lg max-w-2xl mx-auto mb-4 sm:mb-5 font-medium leading-snug" data-id="element-129">
        Die komplette Basketball-Bibel – 200+ fertige Einheiten, Drills, Spiele
        und Planungstools. Alles für Sie vorbereitet.
      </p>

      {/* Mockup image — capped to viewport */}
      <div className="relative w-full max-w-[240px] sm:max-w-[380px] mx-auto mb-4 sm:mb-5" data-id="element-130">
        <img src="https://cdn.magicpatterns.com/uploads/v8CQrGjZEB7TaLfVWM9c4T/Diseno-sin-titulo-_78_.webp" alt="BASKETBALL BEREIT 360 — The Complete Kit" className="w-full h-auto max-h-[36vh] sm:max-h-none object-contain mx-auto drop-shadow-2xl" width={600} height={600} fetchPriority="high" data-id="element-131" />
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-3/4 h-10 bg-[#FF6B00] opacity-20 rounded-full pointer-events-none" style={{
        filter: 'blur(40px)'
      }} data-id="element-132" />
      </div>

      {/* Bullets — compact */}
      <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 mb-4 sm:mb-5 max-w-2xl" data-id="element-133">
        {['6 Bände', '5 Boni', '200+ Einheiten', '120+ Drills', 'Alle Altersgruppen'].map((item, i) => <div key={i} className="flex items-center gap-1.5" data-id="element-134">
            <span className="text-[#00C853] text-sm" data-id="element-135">✅</span>
            <span className="text-white text-xs sm:text-sm font-semibold" data-id="element-136">
              {item}
            </span>
          </div>)}
      </div>

      {/* CTA Button */}
      <a href="#pricing" className="btn-cta-green font-black text-base sm:text-2xl px-6 sm:px-12 py-4 sm:py-6 rounded-2xl transition-colors inline-block mb-3.5 w-full sm:w-auto max-w-md shadow-xl" data-id="element-137">
        🚀 HOL DIR BASKETBALL BEREIT 360 — NUR 19 €
      </a>

      {/* Trust badges */}
      <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-6 text-[#B0B0C0] text-[11px] sm:text-sm font-medium" data-id="element-138">
        <span className="flex items-center gap-1.5" data-id="element-139">
          🔒 Sicherer Zahlungsverkehr
        </span>
        <span className="flex items-center gap-1.5" data-id="element-140">⚡ Sofortiger Zugriff</span>
        <span className="flex items-center gap-1.5" data-id="element-141">
          🛡️ 7 Tage Geld-zurück-Garantie
        </span>
      </div>
    </section>;
}